import {OPTION_NO} from "./constants";

export const MATERIALS_IMAGE = {
    "inox": {
        "image": "/wp-content/uploads/2024/06/inox.png",
        "label": "Inox",
    },
    "aluminium": {
        "image": "/wp-content/uploads/2024/06/aluminium.jpg",
        "label": "Aluminium",
    },
    "laiton": {
        "image": "/wp-content/uploads/2024/06/Laiton.png",
        "label": "Laiton",
    },
    "acier": {
        "image": "/wp-content/uploads/2024/06/acier.png",
        "label": "Acier",
    },
    "bois-brut": {
        "image": "/wp-content/uploads/2024/06/mdf-1.png",
        "label": "MDF",
    },
    "melamine": {
        "image": "/wp-content/uploads/2024/06/chene-clair.jpg",
        "label": "Mélaminé",
    },
    "plexi-pmma": {
        "image": "/wp-content/uploads/2024/06/plexi.png",
        "label": "Pmma",
    },
    "plexi-polycarbonate": {
        "image": "/wp-content/uploads/2024/06/poly-alveolaire.png",
        "label": "Polycarbonate",
    },
    "miroir": {
        "image": "/wp-content/uploads/2024/06/miroir.png",
        "label": "Miroir",
    },
    "verre": {
        "image": "/wp-content/uploads/2024/06/Vitre-verre.jpg",
        "label": "Verre",
    },
}

// Finitions
export const MATERIAL_SHADES = {
    "acier": {
        "acier-brut": {
            "mid": "acier-brut",
            "label": "Brut",
            "fullLabel": "Acier brut",
            "image": "/wp-content/uploads/2024/06/acier.png",
            "permalink": "/acier-brut",
        },
        "acier-electro-zingue": {
            "mid": "acier-electro-zingue",
            "label": "Électro zingue",
            "fullLabel": "Acier électro zingue",
            "image": "/wp-content/uploads/2024/06/acier-zingue.png",
            "permalink": "/acier-electro-zingue",
        },
        "acier-larme": {
            "mid": "acier-larme",
            "label": "Larmé",
            "fullLabel": "Acier larmé",
            "image": "/wp-content/uploads/2024/06/acier-larme.png",
            "permalink": "/acier-larme",
        },
        "acier-corten": {
            "mid": "acier-corten",
            "label": "Acier CORTEN",
            "fullLabel": "Acier CORTEN",
            "image": "/wp-content/uploads/2024/06/acier-corten-1.png",
            "permalink": "/acier-corten",
        },
    },
    "inox": {
        "inox-304l-brut": {
            "mid": "inox-304l-brut",
            "label": "Inox 304L Brut",
            "fullLabel": "Inox 304L Brut",
            "image": "/wp-content/uploads/2024/06/inox.png",
            "permalink": "/inox-304l-brut",
        },
        "inox-316l": {
            "mid": "inox-316l",
            "label": "Inox 316L",
            "fullLabel": "Inox 316L",
            "image": "/wp-content/uploads/2024/06/inox.png",
            "permalink": "/inox-316l",
        },
        "inox-brosse": {
            "mid": "inox-brosse",
            "label": "Inox Brossé",
            "fullLabel": "Inox Brossé",
            "image": "/wp-content/uploads/2024/06/inox.png",
            "permalink": "/inox-brosse",
        },
        "inox-larme": {
            "mid": "inox-larme",
            "label": "Inox Larmé",
            "fullLabel": "Inox Larmé",
            "image": "/wp-content/uploads/2024/06/acier-larme.png",
            "permalink": "/inox-larme",
        },
    },
    "aluminium": {
        "alu-brut": {
            "mid": "alu-brut",
            "label": "Brut",
            "fullLabel": "Aluminium brut",
            "image": "/wp-content/uploads/2024/06/aluminium.jpg",
            "permalink": "/aluminium-brut",
        },
        "alu-prelaque-blanc": {
            "mid": "alu-prelaque-blanc",
            "label": "Prélaqué blanc",
            "fullLabel": "Aluminium prélaqué blanc",
            "image": "/wp-content/uploads/2024/06/aluminium-laque.jpg",
            "permalink": "/aluminium-prelaque-blanc",
        },
    },
    "laiton": {
        "laiton-brut": {
            "mid": "laiton-brut",
            "label": "Brut",
            "fullLabel": "Laiton brut",
            "image": "/wp-content/uploads/2024/06/Laiton.png",
            "permalink": "/laiton-brut",
        },
    },
    "melamine": {
        "melamine-unis-noir": {
            "mid": "melamine-unis-noir",
            "label": "Noir mat",
            "subLabel": "12, 19 & 28mm",
            "fullLabel": "Mélaminé unis noir",
            "image": "/wp-content/uploads/2024/06/noir.jpg",
            "permalink": "/melamine-unis-noir",
            "option": "Pose de chants",
        },
        "melamine-unis-blanc": {
            "mid": "melamine-unis-blanc",
            "label": "Mélaminé unis blanc",
            "subLabel": "12, 19 & 28mm",
            "fullLabel": "Blanc",
            "image": "/wp-content/uploads/2024/06/blanc.jpg",
            "permalink": "/melamine-unis-blanc",
            "option": "Pose de chants",
        },
        "melamine-bois-chene-clair": {
            "mid": "melamine-bois-chene-clair",
            "label": "Chêne clair",
            "subLabel": "12, 19 & 28mm",
            "fullLabel": "Chêne Halifax",
            "image": "/wp-content/uploads/2024/06/chene-clair.jpg",
            "permalink": "/melamine-bois-chene-clair",
            "option": "Pose de chants",
        },
        "melamine-bois-chene-blanchis": {
            "mid": "melamine-bois-chene-blanchis",
            "label": "Chêne blanchis",
            "subLabel": "12, 19 & 28mm",
            "fullLabel": "Chêne Vicenza",
            "image": "/wp-content/uploads/2024/06/chene-blanchis.jpg",
            "permalink": "/melamine-bois-chene-blanchis",
            "option": "Pose de chants",
        },
        "melamine-bois-noyer": {
            "mid": "melamine-bois-noyer",
            "label": "Noyer",
            "subLabel": "12, 19 & 28mm",
            "fullLabel": "Noyer",
            "image": "/wp-content/uploads/2024/06/noyer.jpg",
            "permalink": "/melamine-bois-noyer",
            "option": "Pose de chants",
        },
    },
    "bois-brut": {
        "bois-brut-mdf": {
            "mid": "bois-brut-mdf",
            "label": "MDF",
            "subLabel": "12, 19 & 30mm",
            "fullLabel": "MDF",
            "image": "/wp-content/uploads/2024/06/mdf-1.png",
            "permalink": "/bois-brut-mdf",
        },
    },
    "plexi-pmma": {
        "plexi-pmma-noir": {
            "mid": "plexi-pmma-noir",
            "label": "PMMA noir opaque",
            "fullLabel": "PMMA noir opaque",
            "image": "/wp-content/uploads/2024/06/pmma-noir.png",
            "permalink": "/plexi-pmma-noir",
        },
        "plexi-pmma-blanc": {
            "mid": "plexi-pmma-blanc",
            "label": "PMMA blanc opaque",
            "fullLabel": "PMMA blanc opaque",
            "image": "/wp-content/uploads/2024/06/pmma-blanc.png",
            "permalink": "/plexi-pmma-blanc",
        },
        "plexi-pmma-transparent": {
            "mid": "plexi-pmma-transparent",
            "label": "PMMA transparent",
            "fullLabel": "PMMA transparent",
            "image": "/wp-content/uploads/2024/06/plexi.png",
            "permalink": "/plexi-pmma-transparent",
        },
        "plexi-pmma-diffusant": {
            "mid": "plexi-pmma-diffusant",
            "label": "PMMA blanc diffusant 40%",
            "fullLabel": "PMMA diffusant blanc diffusant 40%",
            "image": "/wp-content/uploads/2024/06/pmma-diffusant-1.png",
            "permalink": "/plexi-pmma-diffusant",
        },
        "plexi-pmma-extrude-miroir-argent": {
            "mid": "plexi-pmma-extrude-miroir-argent",
            "label": "PMMA extrudé miroir argent",
            "fullLabel": "PMMA extrudé miroir argent",
            "image": "/wp-content/uploads/2024/06/pmma-miroir-argent.png",
            "permalink": "/plexi-pmma-extrude-miroir-argent",
        },
        "plexi-pmma-extrude-miroir-or": {
            "mid": "plexi-pmma-extrude-miroir-or",
            "label": "PMMA extrudé miroir or",
            "fullLabel": "PMMA extrudé miroir or",
            "image": "/wp-content/uploads/2024/06/pmma-miroir-or.jpg",
            "permalink": "/plexi-pmma-extrude-miroir-or",
        },
    },
    "plexi-polycarbonate": {
        "plexi-polycarbonate-transparent": {
            "mid": "plexi-polycarbonate-transparent",
            "label": "Polycarbonate transparent",
            "fullLabel": "Polycarbonate transparent",
            "image": "/wp-content/uploads/2024/05/poly-transparent.png",
            "permalink": "/plexi-polycarbonate-transparent",
        },
        "plexi-polycarbonate-alveolaire": {
            "mid": "plexi-polycarbonate-alveolaire",
            "label": "Polycarbonate alveolaire",
            "fullLabel": "Polycarbonate alveolaire",
            "image": "/wp-content/uploads/2024/06/poly-alveolaire.png",
            "permalink": "/plexi-polycarbonate-alveolaire",
        },
    },
    "verre": {
        "verre-transparent": {
            "mid": "verre-transparent",
            "label": "Verre transparent",
            "fullLabel": "Verre transparent",
            "image": "/wp-content/uploads/2024/05/verre.png",
            "permalink": "/verre-transparent",
        },
        "verre-noir": {
            "mid": "verre-noir",
            "label": "Verre noir",
            "fullLabel": "Verre noir",
            "image": "/wp-content/uploads/2024/05/verre.png",
            "permalink": "/verre-noir",
        },
        "verre-blanc": {
            "mid": "verre-blanc",
            "label": "Verre blanc",
            "fullLabel": "Verre blanc",
            "image": "/wp-content/uploads/2024/05/verre.png",
            "permalink": "/verre-blanc",
        },
        "verre-transparent-trempe": {
            "mid": "verre-transparent-trempe",
            "label": "Verre transparent trempé",
            "fullLabel": "Verre transparent trempé",
            "image": "/wp-content/uploads/2024/05/verre.png",
            "permalink": "/verre-transparent-trempe",
        },
    },
    "miroir": {
        "miroir-clair": {
            "mid": "miroir-clair",
            "label": "Miroir clair",
            "fullLabel": "Miroir clair",
            "image": "/wp-content/uploads/2024/06/miroir.png",
            "permalink": "/miroir-clair",
        },
    },
}

export const MATERIAL_DENSITY = {
    "acier-brut": 8,
    "acier-electro-zingue": 8,
    "acier-larme": 8,
    "acier-corten": 8,
    "inox-304l-brut": 8,
    "inox-316l": 8,
    "inox-brosse": 8,
    "inox-larme": 8,
    "alu-brut":  3,
    "alu-prelaque-blanc":  3,
    "laiton-brut": 9,
    "laiton-brosse": 9,
    "laiton-miroir": 9,
    "melamine-unis-noir": 0.75,
    "melamine-unis-blanc": 0.75,
    "melamine-bois-chene-clair": 0.75,
    "melamine-bois-chene-blanchis": 0.75,
    "melamine-bois-noyer": 0.75,
    "bois-brut-mdf": 0.75,
    "plexi-pmma-noir": 1.5,
    "plexi-pmma-blanc": 1.5,
    "plexi-pmma-transparent": 1.5,
    "plexi-pmma-diffusant": 1.5,
    "plexi-pmma-extrude-miroir-argent": 1.5,
    "plexi-pmma-extrude-miroir-or": 1.5,
    "plexi-polycarbonate-transparent": 2,
    "plexi-polycarbonate-alveolaire": 2,
    "verre-transparent": 2.4,
    "verre-noir": 2.4,
    "verre-blanc": 2.4,
    "verre-transparent-trempe": 2.4,
    "miroir-clair": 2.4,
}

export const MATERIAL_THICKNESS = {
    "acier-brut": [1, 1.5, 2, 3, 4, 5, 6, 8, 10, 12],
    "acier-electro-zingue": [1, 1.5, 2, 3, 4, 5, 6, 8, 10, 12],
    "acier-larme": [0.6],
    "acier-corten": [2, 3],
    "inox-304l-brut": [1, 1.5, 2, 3, 4, 5, 6, 8, 10, 12],
    "inox-316l": [1, 1.5, 2, 3],
    "inox-brosse": [1, 1.5, 2, 3, 4, 5, 6, 8, 10, 12],
    "inox-larme": [0.6],
    "alu-brut":  [1, 1.5, 2, 3, 4, 5, 6, 8],
    "alu-prelaque-blanc":  [1.5],
    "laiton-brut": [1, 2],
    "melamine-unis-noir": [12, 19, 28],
    "melamine-unis-blanc": [12, 19, 28],
    "melamine-bois-chene-clair": [12, 19, 28],
    "melamine-bois-chene-blanchis": [12, 19, 28],
    "melamine-bois-noyer": [12, 19, 28],
    "bois-brut-mdf": [12,19,30],
    "plexi-pmma-noir": [2, 6],
    "plexi-pmma-blanc": [3, 6],
    "plexi-pmma-transparent": [2, 3, 4, 5, 6],
    "plexi-pmma-diffusant": [3],
    "plexi-pmma-extrude-miroir-or": [3],
    "plexi-pmma-extrude-miroir-argent": [3],
    "plexi-polycarbonate-transparent": [3, 6, 10],
    "plexi-polycarbonate-alveolaire": [10, 16, 32],
    "verre-transparent": [4, 6],
    "verre-noir": [4],
    "verre-blanc": [4],
    "verre-transparent-trempe": [4, 6],
    "miroir-clair": [4, 6],
}

export const MATERIAL_MIN_PRICE = {
    "bois-brut-mdf": {
        "12": 18,
        "19": 20,
        "30": 31,
    },
    "melamine-unis-noir": {
        "12": {
            "brut": 20,
            "avec-chants": 24,
        },
        "19": {
            "brut": 22,
            "avec-chants": 28,
        },
        "28": {
            "brut": 29,
            "avec-chants": 36,
        },
    },
    "melamine-unis-blanc": {
        "12": {
            "brut": 16,
            "avec-chants": 19,
        },
        "19": {
            "brut": 18,
            "avec-chants": 21,
        },
        "28": {
            "brut": 26,
            "avec-chants": 31,
        },
    },
    "melamine-bois-chene-clair": {
        "12": {
            "brut": 27,
            "avec-chants": 31,
        },
        "19": {
            "brut": 31,
            "avec-chants": 34,
        },
        "28": {
            "brut": 37,
            "avec-chants": 46,
        },
    },
    "melamine-bois-chene-blanchis": {
        "12": {
            "brut": 20,
            "avec-chants": 24,
        },
        "19": {
            "brut": 22,
            "avec-chants": 28,
        },
        "28": {
            "brut": 29,
            "avec-chants": 36,
        },
    },
    "melamine-bois-noyer": {
        "12": {
            "brut": 20,
            "avec-chants": 24,
        },
        "19": {
            "brut": 22,
            "avec-chants": 28,
        },
        "28": {
            "brut": 29,
            "avec-chants": 36,
        },
    },
    "verre-transparent": {
        "4": {
            "form-a": 17.87,
            "form-b": 26.8,
            "form-c": 35.73,
        },
        "6": {
            "form-a": 27.14,
            "form-b": 40.7,
            "form-c": 54.27,
        }
    },
    "verre-noir": {
        "4": {
            "form-a": 45,
            "form-b": 67,
            "form-c": 90,
        },
    },
    "verre-blanc": {
        "4": {
            "form-a": 45,
            "form-b": 67,
            "form-c": 90,
        },
    },
    "verre-transparent-trempe": {
        "4": {
            "form-a": 31.8,
            "form-b": 47.7,
            "form-c": 63.6,
        },
        "6": {
            "form-a": 35.4,
            "form-b": 53.1,
            "form-c": 70.8,
        }
    },
    "miroir-clair": {
        "4": {
            "form-a": 21,
            "form-b": 31.5,
            "form-c": 42,
        },
        "6": {
            "form-a": 27,
            "form-b": 40.5,
            "form-c": 54,
        }
    },
}
// Prices matrix
export const MATERIAL_PRICE = {
    "acier-brut": {
        "1": 48,
        "1.5": 72,
        "2": 96,
        "3": 144,
        "4": 192,
        "5": 240,
        "6": 288,
        "8": 384,
        "10": 480,
        "12": 576,
    },
    "acier-electro-zingue": {
        "1": 48,
        "1.5": 72,
        "2": 96,
        "3": 144,
        "4": 192,
        "5": 240,
        "6": 288,
        "8": 384,
        "10": 480,
        "12": 576,
    },
    "acier-larme": {
        "0.6": 192,
    },
    "acier-corten": {
        "2": 160,
        "3": 240,
    },
    "inox-304l-brut": {
        "1": 96,
        "1.5": 144,
        "2": 192,
        "3": 288,
        "4": 384,
        "5": 480,
        "6": 576,
        "8": 768,
        "10": 960,
        "12": 1152,
    },
    "inox-316l": {
        "1": 128,
        "1.5": 192,
        "2": 256,
        "3": 384,
        "4": 512,
        "5": 640,
        "6": 768,
        "8": 1024,
        "10": 1280,
        "12": 1536,
    },
    "inox-brosse": {
        "1": 128,
        "1.5": 192,
        "2": 256,
        "3": 384,
        "4": 512,
        "5": 640,
        "6": 768,
        "8": 1024,
        "10": 1280,
        "12": 1536,
    },
    "inox-larme": {
        "0.6": 384,
    },
    "alu-brut": {
        "1": 48,
        "1.5": 72,
        "2": 96,
        "3": 144,
        "4": 192,
        "5": 240,
        "6": 288,
        "8": 384,
    },
    "alu-prelaque-blanc":  {
        "1.5": 72,
    },
    "laiton-brut": {
        "1": 160,
        "2": 320,
    },
    "bois-brut-mdf": {
        "12": 59,
        "19": 65,
        "30": 101,
    },
    "melamine-unis-noir": {
        "12": {
            "brut": 65,
            "avec-chants": 78,
        },
        "19": {
            "brut": 72,
            "avec-chants": 91,
        },
        "28": {
            "brut": 95,
            "avec-chants": 117,
        },
    },
    "melamine-unis-blanc": {
        "12": {
            "brut": 53,
            "avec-chants": 63,
        },
        "19": {
            "brut": 58,
            "avec-chants": 69,
        },
        "28": {
            "brut": 87,
            "avec-chants": 102,
        },
    },
    "melamine-bois-chene-clair": {
        "12": {
            "brut": 89,
            "avec-chants": 101,
        },
        "19": {
            "brut": 101,
            "avec-chants": 111,
        },
        "28": {
            "brut": 122,
            "avec-chants": 152,
        },
    },
    "melamine-bois-chene-blanchis": {
        "12": {
            "brut": 65,
            "avec-chants": 78,
        },
        "19": {
            "brut": 72,
            "avec-chants": 91,
        },
        "28": {
            "brut": 95,
            "avec-chants": 117,
        },
    },
    "melamine-bois-noyer": {
        "12": {
            "brut": 65,
            "avec-chants": 78,
        },
        "19": {
            "brut": 72,
            "avec-chants": 91,
        },
        "28": {
            "brut": 95,
            "avec-chants": 117,
        },
    },
    "plexi-pmma-noir": {
        "2": 228,
        "6": 318,
    },
    "plexi-pmma-blanc": {
        "3": 230,
        "6": 322,
    },
    "plexi-pmma-transparent": {
        "2": 224,
        "3": 226,
        "4": 262,
        "5": 294,
        "6": 329,
    },
    "plexi-pmma-diffusant": {
        "3": 230,
    },
    "plexi-pmma-extrude-miroir-argent": {
        "3": 304,
    },
    "plexi-pmma-extrude-miroir-or": {
        "3": 381,
    },
    "plexi-polycarbonate-transparent": {
        "3": 99,
        "6": 99,
        "10": 99,
    },
    "plexi-polycarbonate-alveolaire": {
        "10": 99,
        "16": 99,
        "32": 99,
    },
    "verre-transparent": {
        "4": {
            "form-a": 39.7,
            "form-b": 59.55,
            "form-c": 79.40,
        },
        "6": {
            "form-a": 60.30,
            "form-b": 90.45,
            "form-c": 120.60,
        }
    },
    "verre-noir": {
        "4": {
            "form-a": 150,
            "form-b": 225,
            "form-c": 300,
        },
        "6": {
            "form-a": 150,
            "form-b": 225,
            "form-c": 300,
        }
    },
    "verre-blanc": {
        "4": {
            "form-a": 150,
            "form-b": 225,
            "form-c": 300,
        },
        "6": {
            "form-a": 150,
            "form-b": 225,
            "form-c": 300,
        }
    },
    "verre-transparent-trempe": {
        "4": {
            "form-a": 106,
            "form-b": 159,
            "form-c": 212,
        },
        "6": {
            "form-a": 118,
            "form-b": 177,
            "form-c": 236,
        }
    },
    "miroir-clair": {
        "4": {
            "form-a": 70,
            "form-b": 105,
            "form-c": 140,
        },
        "6": {
            "form-a": 90,
            "form-b": 135,
            "form-c": 180,
        }
    },
}

export const MATERIAL_INFO = {
    "acier-brut": "Résitant et durable",
    "acier-electro-zingue": "Traitement anti-corosion, idéal pour mise en peinture",
    "acier-larme": "Relief anti-dérapent",
    "inox-304l-brut": "Norme alimentaire ",
    "inox-316l": "Milieu marin et piscine",
    "inox-brosse": "Inoxidable et estétique",
    "inox-larme": "Relief anti-dérapent",
    "alu-brut":  "Résistant et léger",
    "alu-prelaque-blanc":  "Une face blanche",
    "laiton-brut": "Noble et rustique",
    "laiton-brosse": "Noble et estétique",
    "laiton-miroir": "Brillance couleur or",
    "melamine-unis-noir": "Aggloméré faces noires",
    "melamine-unis-blanc": "Aggloméré faces blanches",
    "melamine-bois-chene-clair": "Aggloméré faces décor",
    "melamine-bois-chene-blanchis": "Aggloméré faces décor",
    "melamine-bois-noyer": "Aggloméré faces décor",
    "bois-brut-mdf": "Panneau de fibre à densité moyenne",
    "plexi-pmma-noir": "Plexi haute brillance",
    "plexi-pmma-blanc": "Plexi haute brillance",
    "plexi-pmma-transparent": "Plexi haute transaparence",
    "plexi-pmma-diffusant": "Opaque laissant passé la lumière",
    "plexi-polycarbonate-transparent": "Plexi très résistant aux chocs",
    "plexi-polycarbonate-alveolaire": "Idéal pour la protection des potagés, serres et vérandas",
    "verre-transparent": "Verre standard",
    "verre-noir": "Verre laqué noir",
    "verre-blanc": "Verre laqué blanc",
    "verre-transparent-trempe": "Verre traité sécurité",
    "miroir-clair": "Miroir standard",
}

export const DECOUPE_FORMS_MV_ONLY = {
    "mv-rect-percage" : {
        fid: "mv-rect-percage",
        label: "Rectangle avec perçages",
        image: "/wp-content/uploads/2023/09/dc-rect-percage.png",
        iconDetail: "/wp-content/uploads/2023/09/rectangle_avec_percages@2x.png",
        dimensions: ["A", "B", "x", "y"],
    },
    "mv-rect-double" : {
        fid: "mv-rect-double",
        label: "Rectangle avec perçage double",
        image: "/wp-content/uploads/2024/05/rect-double.png",
        iconDetail: "/wp-content/uploads/2024/05/rect-p-double.png",
        dimensions: ["A", "B", "x", "y"],
    },
    "mv-rect-triple" : {
        fid: "mv-rect-triple",
        label: "Rectangle avec perçage triple",
        image: "/wp-content/uploads/2024/05/rect-triple.png",
        iconDetail: "/wp-content/uploads/2024/05/rect-p-triple.png",
        dimensions: ["A", "B", "x", "y"],
    },
}
export const DECOUPE_FORMS_BOIS_ONLY = {
    "b_rect_enc" : {
        fid: "b_rect_enc",
        label: "Rectangle avec encoche",
        image: "/wp-content/uploads/2023/09/dc-rect-c-coin.png",
        iconDetail: "/wp-content/uploads/2023/09/rectangle_et_coupe_en_coin@2x.png",
        iconDetailOption: "/wp-content/uploads/2024/05/rect-enc-dt.png",
        dimensions: ["A", "B", "x", "y"],
        faces: ["f1", "f2", "f3", "f4", "f5", "f6"],
    }
}
export const DECOUPE_FORMS_BOIS_PLEXI_MV = {
    "bpmv_rect" : {
        fid: "bpmv_rect",
        label: "Rectangle",
        image: "/wp-content/uploads/2024/05/rect.png",
        iconDetail: "/wp-content/uploads/2024/05/rect-dt.png",
        iconDetailOption: "/wp-content/uploads/2024/03/rectangle-carre.png",
        dimensions: ["A", "B"],
        faces: ["f1", "f2", "f3", "f4"],
    },
    "bpmv_triangle" : {
        fid: "bpmv_triangle",
        label: "Triangle",
        image: "/wp-content/uploads/2024/05/triangle.png",
        iconDetail: "/wp-content/uploads/2024/05/triangle-dt.png",
        iconDetailOption: "/wp-content/uploads/2024/03/triangle.png",
        dimensions: ["A", "B"],
        faces: ["f1", "f2", "f3"],
    },
    "bpmv_hexagone" : {
        fid: "bpmv_hexagone",
        label: "Hexagone",
        image: "/wp-content/uploads/2024/05/hexa.png",
        iconDetail: "/wp-content/uploads/2024/05/hexa-dt.png",
        iconDetailOption: "/wp-content/uploads/2024/03/hexagone.png",
        dimensions: ["A"],
        faces: ["f1", "f2", "f3", "f4", "f5", "f6"],
    },
    "bpmv_cercle" : {
        fid: "bpmv_cercle",
        label: "Cercle",
        image: "/wp-content/uploads/2024/05/cercle.png",
        iconDetailOption: "/wp-content/uploads/2024/05/cercle-dt.png",
        iconDetail: "/wp-content/uploads/2024/03/cercle.png",
        dimensions: ["A"],
        faces: ["f1"],
    },
    "bpmv_arc" : {
        fid: "bpmv_arc",
        label: "Arc",
        image: "/wp-content/uploads/2024/05/arc.png",
        iconDetail: "/wp-content/uploads/2024/06/arc-dt.png",
        iconDetailOption: "/wp-content/uploads/2024/06/arc.png",
        dimensions: ["A", "B", "x"],
        faces: ["f1", "f2"],
    },
}
export const DECOUPE_FORMS = {
    "rect" : {
        fid: "rect",
        label: "Rectangle",
        image: "/wp-content/uploads/2023/09/dc-rectangle.png",
        iconDetail: "/wp-content/uploads/2023/09/rectangle@2x.png",
        dimensions: ["A", "B"],
    },
    "cadre-cr" : {
        fid: "cadre-cr",
        label: "Cadre et coupe rectangle",
        image: "/wp-content/uploads/2023/09/dc-cadre-cr.png",
        iconDetail: "/wp-content/uploads/2024/05/rect-c-rect-dt.png",
        dimensions: ["A", "B", "x", "y", "dA", "dB"],
    },
    "cadre-cc" : {
        fid: "cadre-cc",
        label: "Cadre et coupe circulaire",
        image: "/wp-content/uploads/2023/09/dc-cadre-cc.png",
        iconDetail: "/wp-content/uploads/2024/05/rect-c-c-dt.png",
        dimensions: ["A", "B", "x", "dA", "dB"],
    },
    "disque" : {
        fid: "disque",
        label: "Disque",
        image: "/wp-content/uploads/2023/09/dc-cercle.png",
        iconDetail: "/wp-content/uploads/2023/09/cercle@2x2.png",
        dimensions: ["A"],
    },
    "anneau" : {
        fid: "anneau",
        label: "Anneau",
        image: "/wp-content/uploads/2023/09/dc-disque-cc.png",
        iconDetail: "/wp-content/uploads/2023/09/anneau@2x1.png",
        dimensions: ["A", "x"],
    },
    "demis-disque-all" : {
        fid: "demis-disque-all",
        label: "Demis-disque et allongé",
        image: "/wp-content/uploads/2023/09/dc-demi-disque.png",
        iconDetail: "/wp-content/uploads/2023/09/demi-disque-allonge@2x.png",
        dimensions: ["A", "B"],
    },
    "rect-cc" : {
        fid: "rect-cc",
        label: "Rectangle et coupe en coin",
        image: "/wp-content/uploads/2023/09/dc-rect-c-coin.png",
        iconDetail: "/wp-content/uploads/2023/09/rectangle_et_coupe_en_coin@2x.png",
        dimensions: ["A", "B", "x", "y"],
    },
    "rect-enc" : {
        fid: "rect-enc",
        label: "Rectangle avec encoche",
        image: "/wp-content/uploads/2023/09/dc-rect-encloche.png",
        iconDetail: "/wp-content/uploads/2023/09/rectangle_avec_encoche@2x.png",
        dimensions: ["A", "B", "x", "y"],
    },
    "triangle" : {
        fid: "triangle",
        label: "Triangle",
        image: "/wp-content/uploads/2023/09/dc-triangle.png",
        iconDetail: "/wp-content/uploads/2023/09/Triangle@2x.png",
        dimensions: ["A", "B"],
    },
    "trapeze" : {
        fid: "trapeze",
        label: "Trapèze",
        image: "/wp-content/uploads/2023/09/dc-trapeze.png",
        iconDetail: "/wp-content/uploads/2023/09/trapeze@2x.png",
        dimensions: ["A", "B", "x"],
    },
    "rect-percage" : {
        fid: "rect-percage",
        label: "Rectangle avec perçages",
        image: "/wp-content/uploads/2023/09/dc-rect-percage.png",
        iconDetail: "/wp-content/uploads/2023/09/rectangle_avec_percages@2x.png",
        dimensions: ["A", "B", "x", "y"],
    },
    "croix" : {
        fid: "croix",
        label: "Croix",
        image: "/wp-content/uploads/2023/09/dc-croix.png",
        iconDetail: "/wp-content/uploads/2023/09/croix@2x.png",
        dimensions: ["A", "B", "x", "y"],
    },
    "ellipse" : {
        fid: "ellipse",
        label: "Ellipse",
        image: "/wp-content/uploads/2023/09/dc-ellipse.png",
        iconDetail: "/wp-content/uploads/2023/09/Ellipse@2x.png",
        dimensions: ["A", "B"],
    },
    "rect-coin-b" : {
        fid: "rect-coin-b",
        label: "Rectangle avec coins biseautés",
        image: "/wp-content/uploads/2023/09/dc-hexa.png",
        iconDetail: "/wp-content/uploads/2023/09/rectangle_biseaute@2x.png",
        dimensions: ["A", "B", "x", "y"],
    },
    "rect-coin-ar" : {
        fid: "rect-coin-ar",
        label: "Rectangle coins arrondis",
        image: "/wp-content/uploads/2023/09/dc-rect-coin-ar.png",
        iconDetail: "/wp-content/uploads/2023/09/rectangle_bord_arrondi@2x.png",
        dimensions: ["A", "B", "x"],
    }
};

export const PLIAGE_FORMS = {
    "pl-f-1" : {
        fid: "pl-f-1",
        label: "Forme 1",
        image: "/wp-content/uploads/2023/09/pli-z.png",
        iconDetail: "/wp-content/uploads/2023/11/pliage_1_3D.png",
        dimensions: ["A", "B", "C", "1", "2", "P"],
    },
    "pl-f-2" : {
        fid: "pl-f-2",
        label: "Forme 2",
        image: "/wp-content/uploads/2023/09/pli-l.png",
        iconDetail: "/wp-content/uploads/2023/11/pliage_2_3D.png",
        dimensions: ["A", "B", "1", "P"],
    },
    "pl-f-3" : {
        fid: "pl-f-3",
        label: "Forme 3",
        image: "/wp-content/uploads/2023/09/pli-u.png",
        iconDetail: "/wp-content/uploads/2023/11/pliage_3_3D.png",
        dimensions: ["A", "B", "C", "1", "2", "P"],
    },
    "pl-f-4" : {
        fid: "pl-f-4",
        label: "Forme 4",
        image: "/wp-content/uploads/2023/09/pli-u2.png",
        iconDetail: "/wp-content/uploads/2023/11/pliage_4_3D.png",
        dimensions: ["A", "B", "C", "D", "E", "1", "2", "3", "4", "P"],
    },
};

export const PRICE_PER_PLI = {
    "pl-f-1": 2,
    "pl-f-2": 1,
    "pl-f-3": 2,
    "pl-f-4": 4,
}
